import {useEffect} from 'react';
import Header from "../Header/Header";
import Product from "./Product";


const products = [
    {
        name: "Acapulco Gold 1gm",
        slug: "acapulco-gold-1gm",
        iamge: "https://i.imgur.com/vWhn8bw.jpg",
        price: 12,
        description: "Acapulco Gold is a rare sativa marijuana strain. As one of the most well-known strains, Acapulco Gold has been likened to dinner at a five-star restaurant."
    },
    {
        name: "Blue Dream 1gm",
        slug: "blue-dream-1gm",
        iamge: "https://i.imgur.com/CKwLGRa.jpg",
        price: 20,
        description: "Blue Dream by Humboldt Seed Organization is a Sativa-dominant feminized cannabis strain much sought after on American soil. If you buy Blue Dream cannabis seeds, you will have the chance to enjoy one of the top ten cannabis strains in the USA."
    },
    {
        name: "Purple Kush 1gm",
        slug: "purple-kush-1gm",
        iamge: "https://i.imgur.com/CG3FKle.jpg",
        price: 13,
        description: "A friend tried comparing Purple Kush to Blue Moon recently, saying he appreciated both for providing a gateway to craft consumption but had since moved on to more complex options. Say whatever you want about Blue Moon, I told the pretentious douche, but don’t you dare besmirch the Purp God."
    },
    {
        name: "Sour Diesel 1gm",
        slug: "sour-diesel-1gm",
        iamge: "https://i.imgur.com/0sYEovN.jpg",
        price: 10,
        description: "Sour Diesel, sometimes called Sour D, is an invigorating sativa named after its pungent, diesel-like aroma. This fast-acting strain delivers energizing, dreamy cerebral effects that have pushed Sour Diesel to its legendary status. Stress, pain, and depression fade away in long-lasting relief that makes Sour Diesel a top choice among medical patients"
    },
    {
        name: "Bubba Kush 1gm",
        slug: "kubba-kush-1gm",
        iamge: "https://i.imgur.com/g6Mnvq4.jpg",
        price: 12,
        description: "Bubba Kush not only provides an easy-going growing experience for newcomers and seasoned cultivators alike, but her buds showcase her balanced and optimized genetics. Anticipate rich and rewarding flavours and aromas coupled with a relaxing high, and a strain that you will want to savour time and time again"
    },
    {
        name: "Granddaddy Purple 1gm",
        slug: "granddaddy-purple-1gm",
        iamge: "https://i.imgur.com/jDsHJjv.jpg",
        price: 11,
        description: "The Granddaddy Purple strain is a notorious Indica-dominant cross between Purple Urkle and Big Bud. People love this marijuana strain because of its classic Indica effects, grape-like aromas, smooth smoke, and massive buds inherited from its noble genetic lineage."
    },
    {
        name: "Afghan Kush 1gm",
        slug: "afghan-kush-1gm",
        iamge: "https://i.imgur.com/N6SGx0d.jpg",
        price: 10,
        description: "Afghan Kush is a landrace strain that originated in the Amu Darya River Valley, nestled on the border of Tajikistan and Uzbekistan. The cultivar grew in the wild for centuries and stabilized its genetic profile through continual natural selection."
    },
    {
        name: "LA Confidential 1gm",
        slug: "la-confidential-1gm",
        iamge: "https://i.imgur.com/GHXktus.jpg",
        price: 10,
        description: "LA Confidential is the multiple award winning mix of OG LA Affie with an undisclosed Afghani. It produces a heavy Kush high – we are talking pure 100% indica here - and a connoisseur level flavour. She has a flowering time of 7-8 weeks and can produce yields of 450g/m². She has become a legend, and deserves a place in any indica enthusiast’s personal stash"
    }
]

const Products = () => {
    useEffect(() => {
        document.title = '0xTuX';
    }, [])
    return (
        <div>
            <Header />
            <div className="container">
                <div className="mt-5 row">            
                    {
                        products.map((product, key) => (
                            <div key={key} className="col-lg-3 col-md-6 col-12 mb-4">
                                <Product product={product} />
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Products
